/* eslint-disable jsx-a11y/alt-text */
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { ApplicationState } from 'store';
import { MyHistoryState } from 'store/modules/my_history_store/types';
import ListItensVencidos from 'components/atoms/list_itens_vencidos';
import Loader from 'components/atoms/loader';
import Pagination from 'components/atoms/pagination';

interface ItensListProps {
  setPageItens: React.Dispatch<React.SetStateAction<number>>;
  pageItens: number;
}

const ItensList = ({ setPageItens, pageItens }: ItensListProps) => {
  const [showPagination, setShowPagination] = useState(false);

  const { my_history, request } = useSelector<ApplicationState, MyHistoryState>(
    (state) => state.session.my_history,
  );

  const handlePaginate = (page: number) => {
    setPageItens(page);
  };

  if (request?.loading) {
    return (
      <div className="card p-4">
        <Loader />
      </div>
    );
  }

  const isPaginationVisible = my_history?.total_itens_vencidos > 7;
  return (
    <div className="card">
      <h6 className="card-title m-3 ml-2 font-weight-bold">Itens vencidos</h6>

      <ListItensVencidos itens={my_history?.itens_vencidos} />

      {isPaginationVisible && (
        <div className="border rounded-bottom border-top-0 d-print-none">
          <button
            type="button"
            className="btn btn-sm btn-link m-0 w-100 mb-3"
            onClick={() => setShowPagination((prev) => !prev)}
          >
            {showPagination ? 'Ver menos' : 'Ver mais'}
          </button>

          {showPagination && (
            <div className="row d-print-none">
              <div className="col-md-12 px-4 mb-5">
                <Pagination
                  postsPerPage={7}
                  totalPosts={my_history.total_itens_vencidos}
                  paginate={handlePaginate}
                  currentPage={pageItens}
                  firstAndLastPage
                />
              </div>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default ItensList;
